import { render, staticRenderFns } from "./ShopWithdraw.vue?vue&type=template&id=12d7ea06"
import script from "./ShopWithdraw.vue?vue&type=script&lang=js"
export * from "./ShopWithdraw.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports